import { IEventDefinition } from "@highway/mbs-analytics";

export const appEvents: Record<string, IEventDefinition> = {
    // Social Studio events
    social_studio_record_new_video_click: {
        description: "Fires when a user clicks the 'Record New Video' button.",
        mappings: {
            mixpanel: "social_studio_record_new_video_click",
        },
    },
    social_studio_script_select: {
        description: "Fires when a user selects a script or creates a custom script.",
        mappings: {
            mixpanel: "social_studio_script_select",
        },
    },
    social_studio_script_edit: {
        description: "Fires when a user edits the script.",
        mappings: {
            mixpanel: "social_studio_script_edit",
        },
    },
    social_studio_script_next_click: {
        description: "Fires when a user clicks 'Next' to proceed to frame selection.",
        mappings: {
            mixpanel: "social_studio_script_next_click",
        },
    },
    social_studio_frame_select: {
        description: "Fires when a user selects a frame.",
        mappings: {
            mixpanel: "social_studio_frame_select",
        },
    },
    social_studio_frame_next_click: {
        description: "Fires when a user clicks 'Next' to proceed to recording.",
        mappings: {
            mixpanel: "social_studio_frame_next_click",
        },
    },
    social_studio_recording_page_view: {
        description: "Fires when a user lands on the recording page.",
        mappings: {
            mixpanel: "social_studio_recording_page_view",
        },
    },
    social_studio_start_recording_click: {
        description: "Fires when a user clicks the 'Start Recording' button.",
        mappings: {
            mixpanel: "social_studio_start_recording_click",
        },
    },
    social_studio_recording_action: {
        description: "Fires when a user interacts with the recording session.",
        mappings: {
            mixpanel: "social_studio_recording_action",
        },
    },
    social_studio_video_preview_page_view: {
        description: "Fires when a user lands on the video preview page.",
        mappings: {
            mixpanel: "social_studio_video_preview_page_view",
        },
    },
    social_studio_branding_select: {
        description: "Fires when a user selects a branding option.",
        mappings: {
            mixpanel: "social_studio_branding_select",
        },
    },
    social_studio_send_mode_toggle: {
        description: "Fires when a user switches the send modal between Individual and Group.",
        mappings: {
            mixpanel: "social_studio_send_mode_toggle",
        },
    },
    social_studio_audience_select: {
        description: "Fires when a user selects a saved audience in the send modal's Group mode.",
        mappings: {
            mixpanel: "social_studio_audience_select",
        },
    },
    social_studio_caption_copy_click: {
        description: "Fires when a user copies the caption.",
        mappings: {
            mixpanel: "social_studio_caption_copy_click",
        },
    },
    marketing_kits_view_campaigns_click: {
        description: 'Fires when the user clicks "View Campaigns" to navigate to Client Manager.',
        mappings: {
            mixpanel: "marketing_kits_view_campaigns_click",
        },
    },
    marketing_kits_step1_submit: {
        description: 'Fires when the user clicks "Next" after selecting reports in Step 1.',
        mappings: {
            mixpanel: "marketing_kits_step1_submit",
        },
    },
    marketing_kits_step1_submit_success: {
        description: "Fires when Step 1 is successfully completed.",
        mappings: {
            mixpanel: "marketing_kits_step1_submit_success",
        },
    },
    marketing_kits_step2_submit: {
        description: 'Fires when the user clicks "Next" after entering inputs in Step 2.',
        mappings: {
            mixpanel: "marketing_kits_step2_submit",
        },
    },
    marketing_kits_step2_submit_success: {
        description: "Fires when Step 2 is successfully completed.",
        mappings: {
            mixpanel: "marketing_kits_step2_submit_success",
        },
    },
    marketing_kits_create_campaign_click: {
        description: 'Fires when the user clicks "Schedule Campaign" in Step 3.',
        mappings: {
            mixpanel: "marketing_kits_create_campaign_click",
        },
    },
    marketing_kits_create_campaign_success: {
        description: "Fires when the campaign is successfully created/scheduled.",
        mappings: {
            mixpanel: "marketing_kits_create_campaign_success",
        },
    },
    marketing_kits_live_link_viewed: {
        description: "Fires when a client opens the live shared link of a Marketing Kit.",
        mappings: {
            mixpanel: "marketing_kits_live_link_viewed",
        },
    },
    // Presentation Expressway events
    pe_featured_slide_download_click: {
        description: 'Fires when the user clicks "Download Slides" in the featured section.',
        mappings: {
            mixpanel: "pe_featured_slide_download_click",
        },
    },
    pe_slide_download_click: {
        description: 'Fires when the user clicks "Download Slides" from the full list of PE slides.',
        mappings: {
            mixpanel: "pe_slide_download_click",
        },
    },
};
